import { createContext, useContext, useState, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('subsdata_token');
    const username = localStorage.getItem('subsdata_username');
    const tenantName = localStorage.getItem('subsdata_tenantName');
    const role = localStorage.getItem('subsdata_role');
    return token ? { token, username, tenantName, role } : null;
  });

  const login = useCallback(async (username, password) => {
    const data = await api.login(username, password);
    localStorage.setItem('subsdata_token', data.token);
    localStorage.setItem('subsdata_username', data.username);
    localStorage.setItem('subsdata_tenantName', data.tenantName);
    localStorage.setItem('subsdata_role', data.role);
    setUser({
      token: data.token,
      username: data.username,
      tenantName: data.tenantName,
      role: data.role
    });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('subsdata_token');
    localStorage.removeItem('subsdata_username');
    localStorage.removeItem('subsdata_tenantName');
    localStorage.removeItem('subsdata_role');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
